import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const ChatGroupPermissionGate = (props: Omit<BasePermissionGateProps<"chat">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="chat"
		/>
	)
}

export default ChatGroupPermissionGate
